import { Slide01Title } from './Slide01Title'
import { SlideLifecycleTail } from './SlideLifecycleTail'
import { SlideFormatByPhase } from './SlideFormatByPhase'
import { SlideValueCalculator } from './SlideValueCalculator'
import { SlideAgencyOfRecord } from './SlideAgencyOfRecord'
import { SlideSnakDefinition } from './SlideSnakDefinition'
import { SlideOperatingScale } from './SlideOperatingScale'
import { Slide02ExecSummary } from './Slide02ExecSummary'
import { Slide03Background } from './Slide03Background'
import { SlideMasterSnaks } from './SlideMasterSnaks'
import { SlideGovernanceView } from './SlideGovernanceView'
import { SlideCustomerJourneyExamples } from './SlideCustomerJourneyExamples'
import { SlideCampaignCostCalculator } from './SlideCampaignCostCalculator'

export const slides = [
  Slide01Title,
  SlideLifecycleTail,
  SlideFormatByPhase,
  SlideValueCalculator,
  SlideAgencyOfRecord,
  SlideSnakDefinition,
  SlideOperatingScale,
  Slide02ExecSummary,
  Slide03Background,
  SlideMasterSnaks,
  SlideGovernanceView,
  SlideCustomerJourneyExamples,
  SlideCampaignCostCalculator,
]

export const slideTitles: { section: string; title: string }[] = [
  { section: 'Cover', title: 'Established Brands Campaign Strategy' },
  { section: '02', title: 'Three Priorities Across the Product Lifecycle' },
  { section: '03', title: 'As Familiarity Grows, Format Shortens' },
  { section: '04', title: 'The Value of a 1% Improvement' },
  { section: '05', title: 'Snak Agency of Record' },
  { section: '06', title: 'HCPs Don’t Lack Content. They Lack Time.' },
  { section: '07', title: 'Built for Continued Campaigns' },
  { section: '08', title: 'From Attention to Insight' },
  { section: '09', title: 'More Channels to Share' },
  { section: '10', title: 'Suggested Further Master Snaks' },
  { section: '11', title: 'One Governance View' },
  { section: '12', title: 'Snaks Throughout the Customer Journey' },
  { section: '13', title: 'Interactive Campaign Cost Calculator' },
]
